import React from "react";
import { Modal, Upload, Button, message, Divider } from "antd";
import { UploadOutlined, CloudUploadOutlined } from "@ant-design/icons";
import { ApiGateWay } from "../../ApiGateWay/ApiGateWay";
import { assetFileNotAttachedError, assetStoreNotSelectedError, fileUploadAttachFilesMessage, fileUploadError, fileUploadFailed, fileUploadSuccess } from "../../constants/Constants";
const { Dragger } = Upload;
export default function FileUploadModal({
  handleCancel,
  fileList,
  setFileList,
  modalTitle,
  subTitle,
  body,
  visible,
  fileType,
  uploadUrl,
  multipleUpload = false,
  children,
  height,
  width,
  additionalFormData,
  setAdditionalFormData
}) {
  const modalStyles = {
    mask: {
      backdropFilter: "blur(5px)",
    },
  };
  const handleUpload = () => {
    const formData = new FormData();
    if (fileList.length === 0) {
      message.error(assetFileNotAttachedError);
      return;
    }
    if (!!additionalFormData && Object.keys(additionalFormData).length !== 0) { //check if object exists, if yes check it contains keys
      for (const key in additionalFormData) {
        if (Object.hasOwnProperty.call(additionalFormData, key)) {
          formData.append(key, additionalFormData[key]);
        }
      }
    } else {
      message.error(assetStoreNotSelectedError);
      return;
    }

    formData.append("file", fileList[0]);
    ApiGateWay.newSimpleMultipartPost(uploadUrl, formData)
      .then((response) => {
        if (!!response?.errorMessage) {
          message.error(response.errorMessage);
        } else {
          message.success(response.status);
          setAdditionalFormData({})
          setFileList([]);
          handleCancel(); // Close modal after success
        }
      })
      .catch((error) => {
        console.log(error);
        message.error(fileUploadError);
      });
  };

  const uploadProps = {
    multiple: multipleUpload,
    beforeUpload: (file) => {
      let whichFileType = null;
      switch (file?.type) {
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "application/vnd.ms-excel":
          whichFileType = "excel";
          break;
        case "application/pdf":
          whichFileType = "pdf";
          break;
        case "image/jpeg":
        case "image/png":
          whichFileType = "image";
          break;
        default:
          whichFileType = "unsupported";
      }
      if (fileType !== whichFileType) {
        message.error(`You can only upload ${fileType} files!`);
        return Upload.LIST_IGNORE;
      }
      setFileList([file]);
      return Upload.LIST_IGNORE; // Prevent automatic upload
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} + ${fileUploadSuccess}`);
      } else if (status === "error") {
        message.error(`${info.file.name} + ${fileUploadFailed}`);
      }
    },
    onRemove: (file) => {
      setFileList(prevList => prevList.filter(item => item.uid !== file.uid));
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
    fileList,
  };

  function preModalCancel(e) {
    if(!(e.target.tagName == "BUTTON" || e.target.tagName == "SPAN")) return;
    setAdditionalFormData({})
    setFileList([]);
    handleCancel();
  }
  
  return (
    <div>
      {children}
      <Modal
        title={
          <div className="file-upload-title">
            <div className="flex-wrapper">
              <CloudUploadOutlined
                style={{ fontSize: "24px", color: "#1890ff" }}
              />
              <span style={{ paddingLeft: "10px" }}>{modalTitle}</span>
            </div>
            <p className="modal-sub-title">{subTitle}</p>
            <Divider />
          </div>
        }
        open={visible}
        onCancel={preModalCancel}
        styles={modalStyles}
        bodyProps={{
          style: {
            height: height,
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
          },
        }}
        width={width}
        footer={[
          <div className="file-upload-modal-footer">
            <div className="file-upload-action-btn">
              <Button
                type="button"
                className="btn muted-button deca-btn-orange"
                onClick={preModalCancel}
              >
                Cancel
              </Button>
              <Button
                type="button"
                className="btn muted-button deca-btn-yellow"
                onClick={handleUpload}
              >
                Submit
              </Button>
            </div>
          </div>,
        ]}
      >
        <div className="file-upload-content">
          {body}
          <div className="file-upload-area">
            <Dragger {...uploadProps}>
              <div>
                <UploadOutlined
                  style={{ fontSize: "24px", color: "#1890ff" }}
                />
                <p style={{ margin: 0 }}>
                  {fileUploadAttachFilesMessage}
                </p>
              </div>
            </Dragger>
          </div>
        </div>
      </Modal>
    </div>
  );
}
